// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lpwjdezzaylhiuyyugqt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxwd2pkZXp6YXlsaGl1eXl1Z3F0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg0MjcxODAsImV4cCI6MjA3NDAwMzE4MH0.VRiSvr4_I45WiR0knR8no9IFAVIlPG71A3C-IoR1NC4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

// Re-export factory function for backwards compatibility
export function createClientComponentClient() {
  return supabase;
}

// Admin helper used by admin components
export async function callAdmin<T = any>(
  action: string,
  params?: Record<string, any>
): Promise<{ success: boolean; data: T | null; error: string | null }> {
  const { data, error } = await supabase.functions.invoke('admin', {
    body: { action, ...params },
  });
  if (error) {
    return { success: false, data: null, error: error.message };
  }
  return data as { success: boolean; data: T | null; error: string | null };
}
